/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeCardLinkWithMicroAuth} from '../api'

export const useMutationCompleteCardLinkWithMicroAuth = createReactQueryMutationHook('completeCardLinkWithMicroAuth', completeCardLinkWithMicroAuth)
